import { render } from "./PixKeyWizardContainer.vue?vue&type=template&id=08aaca4c"
import script from "./PixKeyWizardContainer.vue?vue&type=script&lang=js"
export * from "./PixKeyWizardContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__